<template>
  <tr
    :key="index"
    :style="{ cursor: 'pointer' }"
    :class="selectedRow == index ? 'indigo lighten-5' : ''"
    @click="selectRow(index)"
  >
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.mid }}
    </td>
    <td class="d-block d-sm-table-cell d-print-table-cell">
      {{ item.merchant_name }}
    </td>
  </tr>
</template>

<script>
export default {
  props: ['options', 'selectedRow', 'item', 'index'],
  methods: {
    selectRow(index) {
      this.$emit('selectRowParent', index);
    },
  },
};
</script>
